import axios from 'axios';

function authHeaders() {
  const token = localStorage.getItem('token');
  return { Authorization: `Bearer ${token}` };
}

/** Drop empty filters so the query string stays clean. */
function cleanParams(params = {}) {
  return Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== '' && value !== null && value !== undefined)
  );
}

const logsAPI = {
  // SuperAdmin only: state-changing requests and sign-in attempts
  async getActivityLogs(params) {
    const response = await axios.get('/api/logs/activity', { headers: authHeaders(), params: cleanParams(params) });
    return response.data;
  },

  // SuperAdmin only: server errors, crashes and 5xx responses
  async getErrorLogs(params) {
    const response = await axios.get('/api/logs/errors', { headers: authHeaders(), params: cleanParams(params) });
    return response.data;
  },

  // SuperAdmin only: delete every stored error row. Returns { deleted }.
  async clearErrorLogs() {
    const response = await axios.delete('/api/logs/errors', { headers: authHeaders() });
    return response.data;
  }
};

export default logsAPI;
